import React from 'react'
import Bredcrumb from '../Common/Bredcrumb'

const PrincipalMessage = () => {
  return (
    <>
      <Bredcrumb title="Principal Message" />
      <section className='mt-4'>
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                          <p>Dear All,</p>
                          <p>I take the pleasure in welcoming you to Mahatma Gandhi Institute of pharmacy (MGIP), an institute dedicated to the proper growth and development of each and every student for a better career prospect.The institute is all set to bring out the potential within each student and provide proper guidance so that their potentials can be utilized to make them future Pharmacist or Pharmaceutical researcher capable of meeting any challenge that will be faced by them after leaving the college.</p>
                          <p>The college provides full support to improve their communication skills, critical thinking abilities, moral values and sense of responsibility. All efforts are made to improve the creativity and problem solving abilities of the students so that they can contribute their best to the society and the country.The infrastructure has been developed with most modern equipment; provisions have also been made to upgrade the same keeping pace with the technological advancements of the time.</p>
                          <p>Mahatma Gandhi Institute of pharmacy has a team of highly qualified, experienced and dedicated faculty who devote their time not only to teaching but also for the overall development of the students. Further, faculty from other renowned institutions are invited to deliver guest lectures to help augment their studies beyond syllabus. We are confident that the students passing out from this college will be technically sound, confident and have good leadership skills.</p>
                          <p>I wish all the best to all the prospective students.</p>
                          <p><h4>Dr. Meena K. Yadav</h4></p>
                          <p>Principal</p>
                    </div>  
                    <div class="col-lg-5">
                          <div class="xs-text-center mt-5">
                              <img src="img/team/meena.png" alt="" class="border-radius-6 w-80" />
                          </div>
                    </div>                 
                </div>
            </div>
        </section>
    </>
  )
}

export default PrincipalMessage
